import { Type } from "class-transformer";

export class DateIntv {
    //netgen start
    @Type(() => Date)
    start: Date;
    @Type(() => Date)
    end: Date;
    //netgen end

    constructor(start: Date, end: Date) {
        this.start = start;
        this.end = end;
    }

    contains(d: Date): boolean {
        return d.getTime() >= this.start.getTime() && d.getTime() <= this.end.getTime();
    }

    intersects(other: DateIntv): boolean {
        return other.end.getTime() >= this.start.getTime() && other.start.getTime() <= this.end.getTime();
    }

}
